import React from 'react'
import './AboutISBA.css'
import Footer from '../Footer'

import '../../App.css'




function AboutISBA() {
    return (
        <div className='about-isba-container'>
            <div className='about-isba-picture'>
                <br /><br /><br /><br /><br /><h1 className='about-us-header'>About ISBA</h1><br /><br /><br /><br /><br /><br /><br />
            </div>

            <div className='pic-text-container'>
                <div className='pic-1'>
                    <img src='images/isba-new-member-pic-sp25-2.jpg' alt='pic-1' />
                </div>
                <div className='text-container'>
                    <h2 className='para-header'>How did ISBA start?</h2>
                    <p className='pic-1-para'>
                        The Indian Student Business Association was made with a very simple idea in mind: Indians are the most represented 
                        international student body, however, unlike other ethnic business clubs, there was no Indian business club. With this in mind,
                        Swaraj Dhakar started ISBA at Indiana University in hopes of uniting students on campus with their ethnicty as Indian and interest in business.
                        
                    </p> 
                </div>
                
            </div>

            <div className='pic-text-container'>
                <div className='pic-1'>
                    <img src='images/isba-award.jpg' alt='pic-1' />
                </div>
                <div className='text-container'>
                    <h2 className='para-header'>Kelley Distinction Award</h2>
                    <p className='pic-1-para'>
                        In the Spring of 2025, just one semester after ISBA started, ISBA was honored with the Kelley Distinction and was given the DEIJB Excellence Award among 60+ Kelley organizations. 
                        This award was only given to one organization that best exemplified diversity, equity, inclusion, justice, and belonging within the Kelley School of Business. We are extremely proud of this accomplishment and are excited for what the future holds for ISBA.
                    </p> 
                </div>
                
            </div>

            <div className='pic-text-container'>
                <div className='pic-1'>
                    <img src='images/ey-event-pic2.jpeg' alt='pic-1' />
                </div>

                <div className='text-container'>
                    <h2 className='para-header'>ISBA's Mission and Vision</h2>
                    <p className='pic-1-para'>
                        ISBA's mission invovles aligning our members with our three core values to ensure they are ready for the world of business that follows after graduating the Kelley School of Business.
                        Our three core values are professionalism, leadership, and networking. Currently, there are 11 members on the ISBA board along with many general members, all trying to advance ISBA as a club on the IU campus.
                        By connecting members to companies such as Ernst and Young, Deloitte, Golman Sachs, etc, we pride ourselves in equipping our members with connections from industry level experts and refine their skill set to help them achieve their goals.
                    </p> 
                </div>
            </div>

            <div className='pic-text-container'>
                <div className='pic-1'>
                    <img src='images/isba-social-pic2.JPG' alt='pic-1' />
                </div>

                <div className='text-container'>
                    <h2 className='para-header'>How can ISBA help you?</h2>
                    <p className='pic-1-para'>
                        ISBA provides many opportunities to students, whether it's professional developlment, alumni connections or finding a community on campus,
                        ISBA will provide a space for students to interact and excel in their careers. With bi-weekly workshops and events held to educate all grade levels, whether you are
                        a freshman nervous about campus life or a junior looking to improve your resume, ISBA will provide you with the necessary tools for your professional development.
                    </p> 
                </div>
            </div>

            

            


            
            
            
                
        </div>
    )
}

export default AboutISBA